<script setup lang="ts">

import StarsBalancePill from '@/components/StarsBalancePill.vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import ThePremium from '@/components/ThePremium.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useEcommerce } from '@/composables/game/ecommerce'
import { computed } from 'vue'

const { buyingItemId, starsBalanceConfirmModalConfig, showStarsBalanceConfirmModal } = useEcommerce()
const isLoading = computed(() => buyingItemId.value !== null)

const starsCount = computed(() => starsBalanceConfirmModalConfig.value.amount)

function hideModal() {
  starsBalanceConfirmModalConfig.value = { amount: 0, accepted: false }
}

function confirmPurchase() {
  starsBalanceConfirmModalConfig.value.accepted = true
}
</script>

<template>
  <TheBottomSheet
    :show="showStarsBalanceConfirmModal"
    bg-fade-class="!z-[805] bg-black/[.66] backdrop-blur-none"
    wrapper-class="!z-[805]"
    content-class="bg-dark-bottom-layer"
    @hide="hideModal"
  >
    <div class="w-full flex flex-col items-center gap-y-12 relative">
      <StarsBalancePill
        class="absolute left-0 -top-6"
        pill-class="bg-transparent px-0"
      />
      <div class="flex flex-col items-center gap-y-3">
        <img
          class="size-[88px] min-w-[88px]"
          src="@/assets/images/dropee-circle.png"
        >
        <div class="flex flex-col items-center">
          <div class="text-center text-light-white text-[24px] leading-8 font-bold -tracking-[0.48px]">
            <T
              key-name="stars_balance.confirm_purchase"
              default-value="Pay with Dropee balance"
            />
          </div>
          <div class="text-center text-white/60 text-base font-medium">
            <T
              key-name="stars_balance.description"
              default-value="You are about to use {count, plural, one {# star} other {# stars}} from your Dropee balance"
              :params="{count: starsCount}"
            />
          </div>
        </div>
      </div>
      <BaseButton
        class="w-full"
        :loading="isLoading"
        @click="confirmPurchase"
      >
        <span
          v-if="!buyingItemId"
          class="flex items-center gap-x-2"
        >
          <T
            key-name="starter_pack.confirm_and_use"
            default-value="Confirm and use"
          />
          <ThePremium :with-tooltip="false" />
          <span class="-ml-0.5">{{ starsCount }}</span>
        </span>
        <T
          v-else
          key-name="lingo.giveaway.transaction.loading_cta"
          default-value="Processing..."
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>